export const defaultScriptValue = "value";
export const maximumSeparatorCharacterCode = 65535; //maximum value is maximum value for UTF-16
export const MenuItemEnum = {
  Homepage: 0,
  Maintenance: 1,
  Integrations: 2,
  Search: 3,
  Notifications: 4,
  Profile: 5,
  Support: 6,
  HomepageOld: 7,
  MaintenanceOld: 8,
};

export const EmptyGuid = "00000000-0000-0000-0000-000000000000";

export const CrossReferenceTypes = {
  Customer: 0,
  ShipTo: 4,
  Item: 1,
  UOM: 2,
  Warehouse: 3,
  Carrier: 5,
  MiscCharges: 6,
  TaxGroup: 7,
};

export const CrossReferenceMappingInsertType = {
  None: 0,
  Replace: 1,
  LowPriority: 2,
  HighPriority: 3,
  Exempt: 4,
};

export const FilterDropDownType = {
  Checkbox: 0,
  CheckboxList: 1,
  Date: 2,
  SearchableCheckboxList: 3,
};

export const FilterType = {
  Archived: 0,
  OnHold: 1,
  Active: 2,
  Unassigned: 3,
}; // SHEP-141: Matches temp Backend enum, OperationsManagerController -> WorkflowManagerFilterType enum

export const StatusFilterType = {
  Error: 0,
  NotQueued: 1,
  Processing: 2,
  Successful: 3,
  PendingAck: 4,
  CompletedWithWarning: 5,
}; // SHEP-141: Matches Backend: MerchantData -> WorkflowRecord.cs -> StatusType enum

export const StandardFeatureType = {
  Misc: 0,
  CrossReference: 1,
}; // SHEP-193: Matches Backend: Merchant Services -> OperationsLibrary -> DomainHierarchy -> Operation.cs -> StandardFeatureType enum

export const RequestStatusEnum = {
  0: "Draft",
  2: "Requested",
  5: "Processing",
  10: "Complete",
}; // SHEP-18: Matches Backend: Merchant Data -> Models -> NewConnectionRequest.cs

export const MappingTypes = {
  Explicit: -1,
  Default: 0,
  Implicit: 1,
};
export const composeSourceParentCatalogList = (
  isRowSelected,
  selectedParentSourceCatalogId,
  selectedParentSourceCatalogMappingType,
  mappedParentCatalogs,
) => {
  const implicitParentMapping = mappedParentCatalogs.find(
    (catalog) => catalog.DefaultMappingType === MappingTypes.Default,
  );
  // if the slected row is a default catalog and the we have an implicit parent mapping
  if (
    isRowSelected &&
    selectedParentSourceCatalogMappingType === MappingTypes.Implicit &&
    implicitParentMapping
  ) {
    return implicitParentMapping.CatalogId;
  }
  // if a row is selected filter by its parent catalog id
  if (isRowSelected) {
    return [selectedParentSourceCatalogId ?? ""];
  }
  // if no row is selected then filter by all mapped catalogs
  return mappedParentCatalogs.map((catalogue) => catalogue.CatalogId);
};
export const ConnectionType = {
  0: "Customer",
  1: "ERP",
  2: "Warehouse",
}; // SHEP-18: Matches Backend: Merchant Data -> Models -> Connection.cs

export const ReferenceType = {
  None: -1,
  Customer: 0,
  Item: 1,
  UOM: 2,
  Warehouse: 3,
  ShipTo: 4,
  Carrier: 5,
  MiscCharges: 6,
}; // SHEP-152: Matches backend: Merchant Data -> Models -> CrossReferenceMapping.cs

const mergeValuesAndDefault = (values, defaultString) => {
  if (defaultString) {
    return { ...values, defaultValue: defaultString };
  }
  return values;
};

export const WithTranslation = (t, step) => {
  if (step?.HasCustomMessage) {
    return step?.DefaultMessage;
  }
  if (step?.Values && step?.Values?.length > 0) {
    const messages = step?.Values.map((value) => {
      return t(
        step.NameOfStep,
        mergeValuesAndDefault(value, step.DefaultMessage),
      );
    });
    return messages.join(", ");
  }
  if (step?.Values && step?.Values?.length == 0) {
    return t(step.NameOfStep, step.DefaultMessage);
  }
  return step?.DefaultMessage;
};

export const ConnectionTypes = {
  Customer: 0,
  ERP: 1,
  Warehouse: 2,
}; // SHEP-18: Matches Backend: Merchant Data -> Models -> Connection.cs

export const ArtifactTypes = {
  PackedOrder: 1028,
};

export const UserRoles = {
  SuperAdmin: "superadmin",
  Admin: "admin",
  Member: "member",
};
